(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yemega-five-builder"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('yemega-five-builder')){class YemegaFiveBuilder extends HTMLElement{connectedCallback(){this.target=Number(this.dataset.target||5);this.message=this.querySelector('[data-yemega-five-message]');this.bar=this.querySelector('[data-yemega-five-bar]');this.steps=Array.from(this.querySelectorAll('[data-yemega-five-step]'));this.header=document.querySelector('#header-group');this.updateSticky=()=>{const headerBottom=this.header?Math.max(0,this.header.getBoundingClientRect().bottom):0;this.style.setProperty('--yemega-sticky-top',headerBottom+'px');const top=this.getBoundingClientRect().top;this.classList.toggle('is-stuck',top<=headerBottom+1)};window.addEventListener('scroll',this.updateSticky,{passive:true});window.addEventListener('resize',this.updateSticky);requestAnimationFrame(this.updateSticky);document.addEventListener('cart:update',()=>this.refresh());document.addEventListener('cart:add',()=>setTimeout(()=>this.refresh(),250));document.addEventListener('submit',e=>{if(e.target?.matches('form[action*="/cart/add"]'))setTimeout(()=>this.refresh(),450)})}disconnectedCallback(){window.removeEventListener('scroll',this.updateSticky);window.removeEventListener('resize',this.updateSticky)}async refresh(){try{const r=await fetch('/cart.js',{headers:{Accept:'application/json'}});if(!r.ok)return;const c=await r.json();const eligible=new Set(["Calze","Calze Baby","Calze Bimba","Calze Bimbo","Calze Donna","Calze Sportive","Calze Uomo","Fantasmini","Mini","Parigine","Solette","Boxer Uomo","Slip Uomo"]);const count=Array.isArray(c.items)?c.items.reduce((sum,item)=>sum+(eligible.has(item.product_type)?Number(item.quantity||0):0),0):0;this.render(Math.min(count,this.target))}catch(e){}}render(count){const remaining=Math.max(this.target-count,0);this.classList.toggle('is-one-away',remaining===1);this.classList.toggle('is-complete',remaining===0);const cta=this.querySelector('.yemega-five-builder__cta');if(cta)cta.hidden=remaining!==0;if(this.bar)this.bar.style.width=Math.min(count/this.target*100,100)+'%';this.steps.forEach((s,i)=>{const done=i<count;s.classList.toggle('is-complete',done);s.textContent=done?'✓':String(i+1)});if(this.message)this.message.textContent=remaining===0?this.dataset.complete:(remaining===1?this.dataset.remainingOne:(this.dataset.remainingTemplate||'').replace('{count}',String(remaining)))}}customElements.define('yemega-five-builder',YemegaFiveBuilder)}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yemega-variant-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yemega-variant-card')) {
    class YemegaVariantCard extends HTMLElement {
      connectedCallback() {
        this.sizeSelect = this.querySelector('[data-yemega-option="size"]');
        this.lengthSelect = this.querySelector('[data-yemega-option="length"]');
        this.variantInput = this.querySelector('[data-yemega-variant-id]');
        this.variantMap = Array.from(this.querySelectorAll('[data-yemega-variant-map] option'));
        this.submitButton = this.querySelector('[data-yemega-submit]');
        this.productLink = this.querySelector('[data-yemega-product-link]');
        this.image = this.querySelector('.yemega-variant-card__image');
        this.price = this.querySelector('[data-yemega-price]');
        this.soldOut = this.querySelector('[data-yemega-sold-out]');

        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-yemega-option]')) this.updateVariant();
        });

        this.updateVariant();

        const form = this.querySelector('form');
        form?.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (!this.submitButton || this.submitButton.disabled || this.submitButton.getAttribute('aria-busy') === 'true') return;
          const desktopLabel = this.submitButton.querySelector('.yemega-add-label--desktop');
          const mobileLabel = this.submitButton.querySelector('.yemega-add-label--mobile');
          const oldDesktop = desktopLabel?.textContent || '';
          const oldMobile = mobileLabel?.textContent || '';
          const setLabels = (text) => {
            if (desktopLabel) desktopLabel.textContent = text;
            if (mobileLabel) mobileLabel.textContent = text;
          };
          this.submitButton.disabled = true;
          this.submitButton.setAttribute('aria-busy', 'true');
          setLabels(this.dataset.adding || '…');
          try {
            const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || result.message || 'Cart error');
            const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
            const cart = await cartResponse.json();
            setLabels(this.dataset.added || '✓');
            this.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'yemega-variant-card',
                data: { source: 'yemega-variant-card', itemCount: Number(cart.item_count || 0), variantId: String(this.variantInput?.value || '') }
              }
            }));
            window.setTimeout(() => setLabels(oldDesktop || oldMobile), 1400);
          } catch (error) {
            setLabels(this.dataset.retry || 'RIPROVA');
            window.setTimeout(() => setLabels(oldDesktop || oldMobile), 1800);
          } finally {
            this.submitButton.removeAttribute('aria-busy');
            this.updateVariant();
          }
        });
      }

      updateVariant() {
        const selectedSize = this.sizeSelect?.value || '';
        const selectedLength = this.lengthSelect?.value || '';

        const selectedVariant = this.variantMap.find((option) => {
          const sizeMatches = !this.sizeSelect || option.dataset.size === selectedSize;
          const lengthMatches = !this.lengthSelect || option.dataset.length === selectedLength;
          return sizeMatches && lengthMatches;
        });

        if (!selectedVariant) {
          if (this.submitButton) this.submitButton.disabled = true;
          return;
        }

        const available = selectedVariant.dataset.available === 'true';

        if (this.variantInput) this.variantInput.value = selectedVariant.value;
        if (this.submitButton) this.submitButton.disabled = !available;
        if (this.productLink) this.productLink.href = selectedVariant.dataset.url;

        if (this.image && selectedVariant.dataset.image) {
          this.image.src = selectedVariant.dataset.image;
          this.image.removeAttribute('srcset');
        }

        if (this.price) {
          const comparePrice = selectedVariant.dataset.comparePrice;
          this.price.innerHTML = comparePrice
            ? '<span>' + selectedVariant.dataset.price + '</span><s>' + comparePrice + '</s>'
            : '<span>' + selectedVariant.dataset.price + '</span>';
        }

        if (!available && !this.soldOut) {
          const badge = document.createElement('span');
          badge.className = 'yemega-variant-card__badge';
          badge.dataset.yemegaSoldOut = '';
          badge.textContent = 'Esaurito';
          this.querySelector('.yemega-variant-card__media')?.appendChild(badge);
          this.soldOut = badge;
        } else if (available && this.soldOut) {
          this.soldOut.remove();
          this.soldOut = null;
        }
      }
    }

    customElements.define('yemega-variant-card', YemegaVariantCard);
  }
  } catch(e) { console.error(e); }
})();

})();
